import React from "react";
import ReactDOM from "react-dom";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import Amplify from "aws-amplify";
import { Provider } from "react-redux";
import "./index.scss";
import App from "./App";
import { store } from "./app/store";
import * as serviceWorker from "./serviceWorker";
import awsconfig from "./awsConfig";
import MvmntTheme from "./styles/theme";
import { TilledObj } from "./types/Tilled";

const Tilled = (window as any).Tilled;

export const tilled: TilledObj = new Tilled(
  process.env.REACT_APP_TILLED_PUBLISHABLE_KEY,
  process.env.REACT_APP_TILLED_ACCOUNT,
  { sandbox: process.env.REACT_APP_TILLED_SANDBOX === "true" },
);

Amplify.configure(awsconfig);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider theme={extendTheme(MvmntTheme)}>
        <App />
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
